import { useMemo } from 'react';

import { selectTransactionDataSettingsByNativeKey } from 'app/modules/dataSettings/selectors';
import { useSelector } from 'react-redux';

import {
  CreatableMultiSelect,
  CreateableMultiSelectProps,
} from 'app/modules/filters/components/CreatableMultiSelect';

export const TxnTypeSelect = <TClearable extends boolean>(
  props: Omit<CreateableMultiSelectProps<TClearable>, 'options'>,
) => {
  const transactionCodes = useSelector(selectTransactionDataSettingsByNativeKey)
    ?.type?.enum_set;

  const options = useMemo(
    () => (transactionCodes ?? []).map((i) => ({ text: i, value: i })),
    [transactionCodes],
  );

  return <CreatableMultiSelect {...props} options={options} />;
};
